import { ActionStatus } from '@/core/types/enums/action-status.enum'
import { zodResolver } from '@hookform/resolvers/zod'
import { useTransition } from 'react'
import { useForm } from 'react-hook-form'
import { createAccountAction } from '../../actions/create-account.action'
import { createAccountSchema } from '../../types/dtos/create-account.dto'

export const useCreateAccount = ({ onSuccess }: { onSuccess: () => void }) => {
  const form = useForm({
    defaultValues: {
      email: '',
      password: '',
      password_confirmation: '',
      birthdate: '',
      name: '',
      username: '',
    },
    resolver: zodResolver(createAccountSchema),
  })

  const [isPending, startTransition] = useTransition()

  const handleSubmit = form.handleSubmit(data => {
    startTransition(async () => {
      const { error, status } = await createAccountAction(data)
      if (status === ActionStatus.SUCCESS) onSuccess()

      if (error) {
        Object.keys(data).forEach(key => {
          if (error.split(' ')?.some(e => e === key)) {
            form.setError(key as keyof typeof data, { message: error })
          }
        })
      }
    })
  })

  return { form, handleSubmit, isPending }
}
